import { Observable } from 'rxjs';
import { PlemsiTokenRepository } from '../domain/PlemsiToken/repository';
import { PlemsiToken } from '../domain/PlemsiToken/model';
import HttpClient from '../utils/http-client';

export class PlemsiTokenRepositoryImplementation extends PlemsiTokenRepository {
  private httpClient: HttpClient;

  constructor() {
    super();
    this.httpClient = new HttpClient('', '');
  }

  updatePlemsiToken(users_id: number, token: string): Observable<PlemsiToken> {
    return this.httpClient.put(`/operations/plemsi_token/${users_id}`, { token });
  }

  getPlemsiToken(users_id: number): Observable<any> {
    return this.httpClient.get(`/operations/plemsi_token/${users_id}`);
  }

  deletePlemsiToken(users_id: number): Observable<void> {
    return this.httpClient.delete(`/operations/plemsi_token/${users_id}`);
  }
}
